import React from "react";

export default function DataTable({ data }) {
  const keys = Object.keys(data[0]);
  return (
    <table border="1" cellPadding="5" style={{ marginTop: 20, width: "80%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          {keys.map((key) => (
            <th key={key}>{key}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((row, i) => (
          <tr key={i}>
            {keys.map((key) => (
              <td key={key}>{row[key]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
